module.exports = __webpack_public_path__ + "static/media/nl.6571ea3d.svg";